<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <form>
          <div class="my-5"></div>
          <div class="row">


            <div class="col-3 offset-1">
            <!-- <div class="form-group">
                <div class="fg-line">
                    <label>País:</label>
                    <div class="select">
                        <select v-model="item.countrySelected" id="countryCode" name="countrySelected" v-validate="'required'" class="form-control">
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="country of optionsCountries" :key="country.code_iso_alfa3" :value="country">{{ country.name_iso }}</option>
                        </select>
                    </div>
                </div>
                <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small>
            </div>-->


              <!-- <div class="form-group">
                <label for="exampleInputEmail1">País</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div> -->
            </div>
            <div class="col-3">
              <div class="form-group">
                <label for="exampleInputEmail1">Provincia</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label for="exampleInputEmail1">Localidad</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3 offset-1">
              <div class="form-group">
                <label for="exampleInputEmail1">Código postal</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label for="exampleInputEmail1">Barrio</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label for="exampleInputEmail1">Calle</label>
                <div class="row">
                  <div class="col-md-12">
                    <date-picker v-model="date" :config="options"></date-picker>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3 offset-1">
              <div class="form-group">
                <label for="exampleInputEmail1">Número de calle</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label for="exampleInputEmail1">Piso</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label for="exampleInputEmail1">Departamento</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3 offset-1">
              <div class="form-group">
                <label for="exampleInputEmail1">Edificio</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="exampleInputEmail1">Comentario</label>
                <textarea maxlength="150" class="form-control" aria-label="With textarea"></textarea>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["clickedNext", "currentStep"],
  /* mixins: [validationMixin], */
  data() {
    return {
      item: {
        countrySelected: ''
      }
    };
  },
  created() {
    this.$emit("can-continue", { value: true });
  },
  watch: {
    $v: {
      handler: function (val) {
        if (!val.$invalid) {
          this.$emit("can-continue", { value: true });
        } else {
          this.$emit("can-continue", { value: false });
        }
      },
      deep: true,
    },
    clickedNext(val) {
      if (val === true) {
        this.$v.form.$touch();
      }
    },
  },
  /* mounted() {
    if (!this.$v.$invalid) {
      this.$emit("can-continue", { value: true });
    } else {
      this.$emit("can-continue", { value: false });
    }
  }, */
};
</script>